export const Review = {
  SetReviewers: "Set Reviewers",
  EmptyReviewers: "No available reviewers",
  SearchReviewers: "Search",
  Members: "members",
  Reviewed: "Reviewed"
}
